import FormRegister from '@/components/FormRegister'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: FormRegister,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}